import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApiConfig} from '../../core/config/api.config';
import {BASE_SERVICE} from '../../core/config/api.constants';
import {endpoint} from '../path.constants';
import {ApiResponse} from '../api-response.model';
import {BaseEnumData, EnumData} from '../enum/enum.model';
import {States} from '../enum/city-state.model';


@Injectable({providedIn: 'root'})
export class BaseService {
    private readonly baseUrl = ApiConfig.getBaseUrl(BASE_SERVICE);

    constructor(private http: HttpClient) {
    }

    getBaseEnum() {
        const headers = new HttpHeaders(ApiConfig.secretKeyHeader());
        return this.http.get<ApiResponse<BaseEnumData>>(
            this.baseUrl + endpoint.base.enum, {headers}
        );
    }

    getCityState() {
        const headers = new HttpHeaders(ApiConfig.secretKeyHeader());
        return this.http.get<ApiResponse<States>>(
            this.baseUrl + endpoint.base.city_state, {headers}
        );
    }

}
